export const FILTER_PERIOD = 'period';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_BRIEFS = 'briefIds';
export const FILTER_AGENCIES = 'agencyIds';

export const FILTERS_DEPENDENCIES = {};

export const COLUMN_ID = 'id';
export const COLUMN_PERIOD = 'startDate';
export const COLUMN_NAME = 'name';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_NETWORK = 'network';
export const COLUMN_PLATFORMS = 'platforms';
export const COLUMN_BRIEFS = 'briefs';
export const COLUMN_TOTAL_BUDGET = 'totalBudgetUsd';
export const COLUMN_COST_MODELS = 'costModels';
export const COLUMN_AGENCIES = 'agencies';
export const COLUMN_INFLUENCER_CHANNELS = 'influencerChannels';
export const COLUMN_INFLUENCER_CAMPAIGNS = 'influencerCampaigns';
export const COLUMN_LAST_UPDATED_BY = 'updatedBy';
export const COLUMN_LAST_UPDATED_DATE = 'updated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'created';
export const ACTION_EDIT = 'Edit';
export const ACTION_DUPLICATE = 'Duplicate';
export const ACTION_DELETE = 'Delete';

export const ADJUST_PROVIDER = 1;
export const APPS_FLYER_PROVIDER = 2;
export const MY_TRACKER_PROVIDER = 3;

export const TEMPLATE_NEW_MASTER_CAMPAIGN = 'newCampaign';
